export const columns = [
    { key: 'name', title: 'Patient Name',sort:true },
    { key: 'age', title: 'Age' },
    { key: 'gender', title: 'Gender' },
    { key: 'modality', title:'Modality Type'},
    { key: 'studyRegion', title:'Study Region'},
    { key: 'priority', title:'Case Study',sort:true},
    { key: 'patientId', title: 'Patient ID' },
    { key: 'uhid', title: 'UHID' },
    { key: 'date', title:'Date',sort:true},
    { key: 'time', title:'Time',sort:true},
    { key: 'phoneNumber', title: 'Contact Number' },
    { key: 'status', title:'Status'},
    { key: 'mppsStatus', title: 'Scan Status'},
    { key: 'actions', title: 'Actions' },
];
